import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { ArrowsClockwise } from "@phosphor-icons/react";

const KIND_LABEL = { welcome: "Welcome", password_reset: "Password reset", payslip: "Payslip", generic: "Other" };

export default function EmailLogPanel({ params }) {
  const [data, setData] = useState({ items: [], total: 0, failed: 0 });
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/email-logs", { params }).then(({ data }) => setData(data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [params.tenant_id]);

  const items = data.items.filter((i) => filter === "all" || i.status === filter);

  return (
    <div className="border border-zinc-200 bg-white rounded-sm p-6 space-y-4" data-testid="email-log-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-display text-xl font-bold">Delivery log</div>
          <div className="text-xs text-zinc-500 mt-1">{data.total} emails sent · <span className={data.failed ? "text-rose-600 font-semibold" : ""}>{data.failed} failed</span></div>
        </div>
        <div className="flex gap-1 items-center">
          {["all", "sent", "failed"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={`text-xs px-2.5 py-1 border rounded-sm capitalize ${filter === f ? "bg-adb-navy text-white border-adb-navy" : "border-zinc-200 hover:bg-zinc-50"}`} data-testid={`email-log-filter-${f}`}>{f}</button>
          ))}
          <Button variant="outline" size="sm" onClick={load} className="rounded-sm ml-2" data-testid="email-log-refresh"><ArrowsClockwise size={14} /></Button>
        </div>
      </div>
      {items.length === 0 ? (
        <div className="text-sm text-zinc-500 py-8 text-center" data-testid="email-log-empty">No emails {filter !== "all" ? filter : "sent"} yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="hr-table text-xs">
            <thead><tr><th>When</th><th>To</th><th>Type</th><th>Subject</th><th>Via</th><th>Status</th></tr></thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} data-testid={`email-log-row-${i.id}`}>
                  <td className="font-mono-plex whitespace-nowrap">{new Date(i.sent_at).toLocaleString()}</td>
                  <td className="font-mono-plex">{i.to}</td>
                  <td>{KIND_LABEL[i.kind] || i.kind}</td>
                  <td className="max-w-[320px] truncate" title={i.subject}>{i.subject}</td>
                  <td><Badge variant="outline" className="rounded-sm">{i.provider === "smtp" ? "Company mailbox" : "Emergent"}</Badge></td>
                  <td>
                    <Badge variant="outline" className={`rounded-sm ${i.status === "sent" ? "bg-emerald-50 text-emerald-700 border-emerald-300" : "bg-rose-50 text-rose-700 border-rose-300"}`}>{i.status}</Badge>
                    {i.error && <div className="text-[10px] text-rose-600 mt-1 max-w-[260px] truncate" title={i.error}>{i.error}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
